define('components/course/models/core-models',[
    'components/course/models/slide-type/background-theme-selection',
    'components/course/models/slide-type/click-and-reveal',
    'components/course/models/slide-type/content',
    'components/course/models/slide-type/full-screen-video',
    'components/course/models/slide-type/full-width',
    'components/course/models/slide-type/half-width',
    'components/course/models/slide-type/interactive-container',
    'components/course/models/slide-type/module-intro',
    'components/course/models/slide-type/post-test',
    'components/course/models/slide-type/pre-test',
    'components/course/models/slide-type/quick-tip',
    'components/course/models/slide-type/survey',
    'components/course/models/slide-type/tab',
    'components/course/models/slide-type/text-image',
    'components/course/models/slide-type/theme-selection',
    'components/course/models/slide-type/video-intro'
], function (BackgroundThemeSelection,
             ClickAndReveal,
             Content,
             FullScreenVideo,
             FullWidth,
             HalfWidth,
             InteractiveContainer,
             ModuleIntro,
             PostTest,
             PreTest,
             QuickTip,
             Survey,
             Tab,
             TextImage,
             ThemeSelection,
             VideoIntro) {
    "use strict";

    var CoreModels = {},
        Type = {
            "BACKGROUND_THEME_SELECTION": "background-theme-selection",
            "CLICK_AND_REVEAL": "click-and-reveal",
            "CONTENT": "content",
            "FULL_SCREEN_VIDEO": "full-screen-video",
            "FULL_WIDTH": "full-width",
            "HALF_WIDTH": "half-width",
            "INTERACTIVE_CONTAINER": "interactive-container",
            "MODULE_INTRO": "module-intro",
            "POST_TEST": "post-test",
            "PRE_TEST": "pre-test",
            "QUICK_TIP": "quick-tip",
            "SURVEY": "survey",
            "TABS": "tabs",
            "TEXT_IMAGE": "text-image",
            "THEME_SELECTION": "theme-selection",
            "VIDEO_INTRO": "video-intro"
        };

    CoreModels[Type.BACKGROUND_THEME_SELECTION] = BackgroundThemeSelection;
    CoreModels[Type.CLICK_AND_REVEAL] = ClickAndReveal;
    CoreModels[Type.CONTENT] = Content;
    CoreModels[Type.FULL_SCREEN_VIDEO] = FullScreenVideo;
    CoreModels[Type.FULL_WIDTH] = FullWidth;
    CoreModels[Type.HALF_WIDTH] = HalfWidth;
    CoreModels[Type.INTERACTIVE_CONTAINER] = InteractiveContainer;
    CoreModels[Type.MODULE_INTRO] = ModuleIntro;
    CoreModels[Type.POST_TEST] = PostTest;
    CoreModels[Type.PRE_TEST] = PreTest;
    CoreModels[Type.QUICK_TIP] = QuickTip;
    CoreModels[Type.SURVEY] = Survey;
    CoreModels[Type.TABS] = Tab;
    CoreModels[Type.TEXT_IMAGE] = TextImage;
    CoreModels[Type.THEME_SELECTION] = ThemeSelection;
    CoreModels[Type.VIDEO_INTRO] = VideoIntro;

    return {
        "CoreModels": CoreModels,
        "Type": Type
    };
});

